import React, { Element } from 'react'
import PropTypes from 'prop-types'

import { Logo, SkipLink } from '../../components'

import headerStyles from '../../containers/Header/Header.scss'

export const MiniHeader = ({ sticky, skipToContentTag, miniHeaderContent, headerRef, routes, dualBrand }) => (
  <header
    id='haas-v2-mini'
    className={`${headerStyles.header}${sticky ? ` ${headerStyles['header--sticky']}` : ''}`}
    ref={headerRef}>
    <div className={headerStyles.main}>
      <div className={headerStyles.container}>
        <Logo routes={routes} dualBrand={dualBrand} />
        <SkipLink skipToContentTag={skipToContentTag} isMiniHeader />
        {miniHeaderContent}
      </div>
    </div>
  </header>
)

MiniHeader.propTypes = {
  dualBrand: PropTypes.bool,
  headerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  miniHeaderContent: PropTypes.element,
  routes: PropTypes.shape({ homePage: PropTypes.func }),
  skipToContentTag: PropTypes.string,
  sticky: PropTypes.bool,
}

MiniHeader.defaultProps = {
  sticky: false,
  dualBrand: false,
  skipToContentTag: '',
  miniHeaderContent: null,
  routes: {},
}

export default MiniHeader
